import React from 'react';
import PropTypes from 'prop-types';

import MobileNavMenu from './MobileNavMenu';
import guidesLinks from '../data/guides';

const { helpGuides, learnMore } = guidesLinks;

const guidesArray = [helpGuides, learnMore];

const MobileNavGuides = ({ onNavListItemClick }) => (
  <MobileNavMenu links={guidesArray} onNavListItemClick={onNavListItemClick} />
);

MobileNavGuides.defaultProps = {
  onNavListItemClick: null,
};

MobileNavGuides.propTypes = {
  onNavListItemClick: PropTypes.func,
};

export default MobileNavGuides;
